<template>
  <div
    class="d-flex justify-content-between"
    style="padding-bottom: 1em"
    :gutter="[0, 0]"
  >
    <!-- Video Title -->
    <a-typography-text strong>
      {{ videoTitle || '-' }}
    </a-typography-text>

    <!-- Visualization Controls -->
    <a-space v-if="showVisualizationControls" :size="25">
      <div v-if="isVisualization" class="d-flex">
        <label for="ai-visualization" class="mr-2">AI-Visualization:</label>
        <a-switch
          id="ai-visualization"
          :checked="showBoundingBoxes"
          checked-children="ON"
          un-checked-children="OFF"
          @change="$emit('update:showBoundingBoxes', $event)"
        />
      </div>
      <div v-if="isClientVisualization" class="d-flex">
        <label for="client-ui" class="mr-2">Client Visualization:</label>
        <a-switch
          id="client-ui"
          :checked="showClientExperience"
          checked-children="ON"
          un-checked-children="OFF"
          @change="$emit('update:showClientExperience', $event)"
        />
      </div>
    </a-space>

    <!-- Right Actions -->
    <a-space>
      <a-select
        v-if="translationLanguage"
        :value="selectedLang"
        :options="languageOptions"
        size="small"
        @change="$emit('languageChange', $event)"
      />
      <template v-if="showNextPrevious">
        <a-button
          type="primary"
          size="small"
          :disabled="prevVideoButtonDisabled"
          @click="$emit('handleVideoChange', -1)"
        >
          Previous
        </a-button>
        <a-button
          class="mr-5"
          type="primary"
          size="small"
          :disabled="nextVideoButtonDisabled"
          @click="$emit('handleVideoChange', 1)"
        >
          Next
        </a-button>
      </template>
      <a-button
        v-else
        type="primary"
        size="small"
        class="ml-2"
        @click="$emit('goToDashboard')"
      >
        Go to Dashboard
      </a-button>
    </a-space>
  </div>
</template>

<script>
export default {
  name: 'TraceHeader',
  props: {
    // Video info
    selectedVideo: {
      type: Object,
      default: () => ({}),
    },
    taskName: {
      type: String,
      default: '',
    },
    modelVersion: {
      type: String,
      default: '',
    },

    // Visualization controls
    showVisualizationControls: {
      type: Boolean,
      default: true,
    },
    isVisualization: {
      type: Boolean,
      default: false,
    },
    showBoundingBoxes: {
      type: Boolean,
      default: false,
    },
    isClientVisualization: {
      type: Boolean,
      default: false,
    },
    showClientExperience: {
      type: Boolean,
      default: false,
    },

    // Language selection
    translationLanguage: {
      type: String,
      default: '',
    },
    selectedLang: {
      type: String,
      default: 'English',
    },
    languageOptions: {
      type: Array,
      default: () => [],
    },
    showNextPrevious: {
      type: Boolean,
      default: false,
    },
    prevVideoButtonDisabled: {
      type: Boolean,
      default: false,
    },
    nextVideoButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:showBoundingBoxes',
    'update:showClientExperience',
    'languageChange',
    'goToDashboard',
    'handleVideoChange',
  ],
  computed: {
    videoTitle() {
      const { fileName } = this.selectedVideo || {};
      if (!fileName) return '';
      return `${fileName} - ${this.taskName} ${this.modelVersion}`.trim();
    },
  },
};
</script>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}
</style>
